<script setup lang="ts">
// Termos e Condições do "Indique e Ganhe" renderizados como um accordion
// único (abre/fecha o card inteiro), conforme o layout do Figma.
const isOpen = ref(false);

const toggle = () => {
  isOpen.value = !isOpen.value;
};
</script>

<template>
  <div class="refers-terms">
    <button
      :aria-expanded="isOpen"
      class="refers-terms__header"
      type="button"
      @click="toggle()"
    >
      <span class="refers-terms__icon-box">
        <NuxtIcon
          class="text-[20px]"
          filled
          name="user/refers-terms-info"
        />
      </span>

      <span class="refers-terms__heading">
        <span class="refers-terms__title">
          Termos e Condições — Indique e Ganhe Aposta Tudo
        </span>
        <span class="refers-terms__subtitle"
          >Tudo o que você precisa saber!</span
        >
      </span>

      <NuxtIcon
        class="refers-terms__chevron"
        name="arrows/angle_down"
      />
    </button>

    <div
      v-show="isOpen"
      class="refers-terms__body"
    >
      <hr class="refers-terms__divider" />

      <section class="refers-terms__section">
        <h3 class="refers-terms__section-title">1. Introdução</h3>
        <p>
          O programa Indique e Ganhe da operadora tem como objetivo premiar
          jogadores que recomendam a plataforma para novos usuários que realizem
          apostas dentro dos critérios estabelecidos neste regulamento.
        </p>
        <p>
          Ao participar, o jogador declara estar de acordo com todos os termos e
          condições descritos abaixo.
        </p>
        <p>
          Ao aceitar os Termos do site, o jogador passa a participar
          automaticamente das promoções, bônus e comunicações da operadora,
          podendo receber ofertas e novidades por diferentes canais (e-mail,
          SMS, notificações, entre outros). O jogador pode cancelar o
          recebimento dessas comunicações a qualquer momento, bastando acessar a
          aba "Dados da Conta" e ajustar suas preferências.
        </p>
      </section>

      <section class="refers-terms__section">
        <h3 class="refers-terms__section-title">2. Elegibilidade</h3>
        <p>
          2.1. Podem participar do programa apenas usuários:<br />
          a) com idade igual ou superior a 18 (dezoito) anos;<br />
          b) com conta verificada (KYC aprovado);<br />
          c) com cadastro ativo na plataforma operadora.
        </p>
        <p>
          2.2. Usuários bloqueados, suspensos, autoexcluídos ou com qualquer
          restrição operacional não podem participar.
        </p>
      </section>

      <section class="refers-terms__section">
        <h3 class="refers-terms__section-title">3. Regras do Programa</h3>
        <p>
          3.1. O usuário poderá compartilhar seu link de indicação com novos
          jogadores ("Indicado").
        </p>
        <p>
          3.2. O Indicado deverá obrigatoriamente:<br />
          a) criar conta na operadora utilizando o link do indicador;<br />
          b) Concluir todos os processos de verificação de identidade (cadastro
          completo + KYC);
        </p>
        <p>
          3.3. Transações canceladas, revertidas, rollback, chargeback ou
          estornos não qualificam para a promoção.
        </p>
        <p
          >3.4. Apenas novas contas serão consideradas válidas para o
          programa.</p
        >
        <p>3.5. Contas de jogadores que compartilhem:</p>
        <ul class="refers-terms__list">
          <li>mesmo dispositivo,</li>
          <li>mesmo IP,</li>
          <li>mesma conta bancária,</li>
        </ul>
        <p>poderão ser desqualificadas por suspeita de vínculo irregular.</p>
      </section>

      <section class="refers-terms__section">
        <h3 class="refers-terms__section-title">4. Recompensa do Indicador</h3>
        <p>
          4.1. Ao compartilhar o link de indicação, o indicador compromete-se a
          identificar o conteúdo como divulgação/publicidade, a não fazer
          promessas de ganho ou linguagem enganosa, e a não direcionar a
          divulgação a menores de 18 anos ou a pessoas impedidas de apostar nos
          termos da legislação vigente.
        </p>
        <p>
          4.2. Ao ser validado o cumprimento das regras, o indicador terá
          direito a R$30,00 em saldo real por indicação qualificada.
        </p>
        <p>
          4.3. O crédito não é automático. O jogador deverá acessar a área
          "Prêmios e Recompensas" e clicar no botão de resgate.
        </p>
        <p>
          4.4. Caso o resgate não seja realizado no prazo de 24 horas, a
          recompensa será cancelada automaticamente, podendo o jogador solicitar
          reanálise mediante contato com o suporte.
        </p>
        <p
          >4.5. Uma vez resgatado, o saldo real não expira e não possui
          rollover.</p
        >
        <p>4.6. Não há limite de indicações qualificadas por jogador.</p>
      </section>

      <section class="refers-terms__section">
        <h3 class="refers-terms__section-title">5. Política Antifraude</h3>
        <p>
          5.1. A operadora se reserva o direito de cancelar a recompensa caso
          identifique:<br />
          a) múltiplas contas de um mesmo jogador;<br />
          b) uso indevido da promoção;<br />
          c) tentativa de fraude ou manipulação do sistema;<br />
          d) contas vinculadas por dados pessoais ou infraestrutura digital
          compartilhada.
        </p>
        <p>5.2. Caso identificada irregularidade, a operadora poderá:</p>
        <ul class="refers-terms__list">
          <li>cancelar recompensas;</li>
          <li>bloquear ou encerrar contas;</li>
          <li>invalidar a participação no programa.</li>
        </ul>
      </section>

      <section class="refers-terms__section">
        <h3 class="refers-terms__section-title">
          6. Obrigações e Responsabilidades
        </h3>
        <p>
          6.1. A operadora não se responsabiliza por compartilhamento incorreto
          do link pelo usuário.
        </p>
        <p>
          6.2. A responsabilidade pelo cumprimento dos requisitos é do indicador
          e do indicado.
        </p>
        <p>
          6.3. A operadora não garante qualquer ganho futuro, sendo a
          participação voluntária.
        </p>
      </section>

      <section class="refers-terms__section">
        <h3 class="refers-terms__section-title">7. Alterações do Programa</h3>
        <p
          >7.1. A operadora poderá, a qualquer momento mediante a aviso
          prévio:</p
        >
        <ul class="refers-terms__list">
          <li>modificar critérios, regras, valores e prazos;</li>
          <li>suspender ou encerrar a campanha;</li>
        </ul>
        <p>Mediante aviso.</p>
      </section>

      <section class="refers-terms__section">
        <h3 class="refers-terms__section-title">8. Disposições Gerais</h3>
        <p>
          8.1. Este programa é disponibilizado de acordo com a legislação
          vigente no Brasil e com os requisitos regulatórios aplicáveis.
        </p>
        <p>
          8.2. O tratamento de dados pessoais observa rigorosamente a Lei Geral
          de Proteção de Dados (LGPD).
        </p>
        <p>
          8.3. Situações omissas serão avaliadas pela operadora, podendo ser
          solicitado o envio de informações adicionais para validação.
        </p>
      </section>

      <p class="refers-terms__closing">
        Ao participar do programa, o usuário declara ciência e concordância
        integral com estes Termos e Condições.<br />
        Ministério da Fazenda adverte: Aposta não é investimento.
      </p>
    </div>
  </div>
</template>

<style scoped lang="scss">
.refers-terms {
  @apply w-full overflow-hidden rounded-xl bg-[#0A192A] px-4 py-3;

  &__header {
    @apply flex w-full cursor-pointer select-none items-center gap-2 bg-transparent text-left;
  }

  &__icon-box {
    @apply flex size-8 shrink-0 items-center justify-center rounded-[10px] bg-[rgba(39,47,63,0.4)] text-white;
  }

  &__heading {
    @apply flex min-w-0 flex-1 flex-col;
  }

  &__title {
    @apply text-sm font-medium text-[#f8fafc];
  }

  &__subtitle {
    @apply text-xs text-[#93a4d5];
  }

  &__chevron {
    @apply shrink-0 text-[18px] text-[#93a4d5] transition-transform duration-200;
  }

  &__header[aria-expanded='true'] &__chevron {
    @apply rotate-180;
  }

  &__body {
    @apply mt-3;
  }

  &__divider {
    @apply mb-3 border-t border-white/10;
  }

  &__section {
    @apply mb-4 last:mb-0;

    p {
      @apply mb-1 text-sm leading-5 text-[#e2e8f0] last:mb-0;
    }
  }

  &__section-title {
    @apply mb-1 text-base font-bold leading-6 text-[#f8fafc];
  }

  &__list {
    @apply my-1 list-disc pl-5 text-sm leading-5 text-[#e2e8f0];
  }

  &__closing {
    @apply mt-4 text-sm leading-5 text-[#e2e8f0];
  }
}
</style>
